<div class="menu-drawer-header">
    <button class="menu-button" mat-icon-button (click)="changeNavWidth()">
        <mat-icon fontSet="fas" fontIcon="fa-bars"></mat-icon>
    </button>
</div>
